import numeral from 'numeral';

export default (value: number) =>
    numeral(value)
        .format('0,0.[0000]a')
        .toUpperCase();
